import { get } from '@namespace/helpers';

const getExpressDay = () => get('/service/lineout/bets/store/express_day/');

export default getExpressDay;
